import User from "../models/User";

const fetchAppSheetOptionsForClient = async ({queryKey, signal}) => {

    let user = TB.auth().user();
    if (!user || !user.canManageClients()) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}
const fetchAppSheetOptionsForProject = async ({queryKey, signal}) => {
    let params = queryKey[1] || {}
    let user = TB.auth().user();
    if (!user || !user.canManageClients() || !params?.projectId) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/projects/${params?.projectId}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}

const fetchForTalentAsManager = async ({queryKey, signal}) => {
    let {talentId} = queryKey[1] || {}

    return User.fetchForTalentAsManager(talentId)
}
const fetchTalentUserStatsForTalentManager = async ({queryKey, signal}) => {

    let request = TB.request(TB.api_endpoint('/api/users/talent/stats'));

    let response = await request.get({signal}).catch(console.warn);

    if (!TB.has(response, 'success.data.stats')) {
        throw new Error('Something Went Wrong');
    }
    return response.success.data.stats
}


const fetchAppSheetOptionsForProjectPosition = async ({queryKey, signal}) => {
    let params = queryKey[1] || {}
    let user = TB.auth().user();
    if (!user || !user.canManageClients() || !params?.projectId || !params?.positionId) {
        throw new Error('Unauthorized')
    }
    const appSheetRequest = TB.request(
        TB.api_endpoint(`/api/appsheet/clients/${user.clientOrg?.()?.id}/projects/${params?.projectId}/positions/${params?.positionId}/options`)
    );

    let response = await appSheetRequest.get({signal}).catch(e => {
        throw new Error(e.message)
    })

    if (!TB.has(response, 'success.data.options')) {
        throw new Error('Something Went Wrong')
    }

    return response.success.data
}

export {
    fetchAppSheetOptionsForClient,
    fetchAppSheetOptionsForProject,
    fetchAppSheetOptionsForProjectPosition,
    fetchForTalentAsManager,
    fetchTalentUserStatsForTalentManager
}